module.exports = __webpack_public_path__ + "static/media/frontlogo.7a5d0e77.svg";